const styles = theme => ({
  root: {
    marginTop: 16,
    marginBottom: 16,
    maxWidth: "100%"
  },
  wrapper: {
    width: "100%",
    background: "#fff"
  },
  centred: {
    width: "100%",
    maxWidth: "1320px",
    alignSelf: "center",
    marginLeft: "auto",
    marginRight: "auto"
  },
  centred2: {
    width: "100%",
    maxWidth: "920px",
    alignSelf: "center",
    marginLeft: "auto",
    marginRight: "auto"
  },
  content: {
    background: "#fff"
  },
  flex: {
    flex: 1
  },
  panel: {
    background: "#efefef"
  },
  context: {
    background: "#efefef"
  },
  contextMenu: {
    maxWidth: 100
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/ui/content/styles.js